export default [
    {
      path: "/inventory/privilege/list",
      name: "inventory-privilege-list",
      component: () => import("@/views/pages/inventory/inventory-privilege/InventoryPrivilegeList.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Inventory Management',
        },
        {
          text: 'Privilege',
          active: true,
        },
      ],
    },
    {
      path: "/inventory/privilege/manage-master/:ref",
      name: "inventory-privilege-manage-master",
      component: () => import("@/views/pages/inventory/inventory-privilege-manage/InventoryManageMaster.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Inventory Management',
        },
        {
          text: 'Privilege',
          active: true,
        },
        {
          text: 'Manage Master',
          active: true,
        },
      ],
    },
    {
      path: "/inventory/privilege/manage-custom/create",
      name: "inventory-privilege-manage-custom-create",
      component: () => import("@/views/pages/inventory/inventory-privilege-manage/InventoryManageCustom.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Inventory Management',
        },
        {
          text: 'Privilege',
          active: true,
        },
        {
          text: 'Add Inventory',
          active: true,
        },
      ],
    },
    {
      path: "/inventory/privilege/manage-custom/info/:ref",
      name: "inventory-privilege-manage-custom-info",
      component: () => import("@/views/pages/inventory/inventory-privilege-manage/InventoryManageCustom.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Inventory Management',
        },
        {
          text: 'Privilege',
          active: true,
        },
        {
          text: 'Manage Inventory',
          active: true,
        },
      ],
    },
    {
      path: "/inventory/privilege/history/group/:ref",
      name: "inventory-privilege-history-group",
      component: () => import("@/views/pages/inventory/inventory-privilege-history/InventoryHistoryGroup.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Inventory Management',
        },
        {
          text: 'Privilege',
          active: true,
        },
        {
          text: 'Manage Master',
          active: true,
        },
        {
          text: 'History',
          active: true,
        },
      ],
    },
    {
      path: "/inventory/privilege/history/group/:ref/detail/:invRef",
      name: "inventory-privilege-history-detail",
      component: () => import("@/views/pages/inventory/inventory-privilege-history/InventoryHistoryDetail.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Inventory Management',
        },
        {
          text: '...',
          active: true,
        },
        {
          text: 'History Detail',
          active: true,
        },
      ],
    },
    {
      path: "/inventory/privilege/history/group/:ref/detail/:invRef/stock",
      name: "inventory-privilege-stock-detail",
      component: () => import("@/views/pages/inventory/inventory-privilege-history/InventoryStockDetail.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Inventory Management',
        },
        {
          text: '...',
          active: true,
        },
        {
          text: 'History Detail',
          active: true,
        },
        {
          text: 'Total Stock',
          active: true,
        }
      ],
    },
    {
      path: "/inventory/privilege/history/group/:ref/detail/:invRef/stock/:stockRef",
      name: "inventory-privilege-stock-detail-byref",
      component: () => import("@/views/pages/inventory/inventory-privilege-history/InventoryStockDetail.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Inventory Management',
        },
        {
          text: '...',
          active: true,
        },
        {
          text: 'History Detail',
          active: true,
        },
        {
          text: 'Serial Stock',
          active: true,
        }
      ],
    },
    {
      path: "/inventory/privilege/history/group/:ref/detail/:invRef/import/:importRef",
      name: "inventory-privilege-import-detail-byref",
      component: () => import("@/views/pages/inventory/inventory-privilege-history/InventoryImportDetail.vue"),
      meta: {
      },
      breadcrumb: [
        {
          text: 'Inventory Management',
        },
        {
          text: '...',
          active: true,
        },
        {
          text: 'History Detail',
          active: true,
        },
        {
          text: 'Import Detail',
          active: true,
        }
      ],
    },
    {
      path: "/inventory/product/list",
      name: "inventory-product-list",
      component: () => import("@/views/pages/inventory/inventory-product/InventoryProductList.vue"),
      meta: {
      },
    },
    {
      path: "/inventory/report",
      name: "inventory-report",
      component: () => import("@/views/pages/inventory/inventory-product/InventoryProductList.vue"),
      meta: {
      },
    },
  ];
  